import { JSX } from 'react';
import { ApplicationState } from '@/store';
import { Box, Button } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { CustomHeading } from 'shared-components';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { SectionTitles, SectionTitleToRoute } from './types';
import { generateFlowSpecificUrl } from './generateFlowSpecificUrl';

export interface ISectionHeaderProps {
  title: SectionTitles;
}

export function SectionHeader({ title }: ISectionHeaderProps): JSX.Element {
  const { application, role, authUni } = useSelector((state: ApplicationState) => ({
    application: state.apply.application,
    role: state.auth.role,
    authUni: state.auth.uni,
  }));

  const uni = application.universityShortcode ?? authUni;

  const { applicationId, userId } = application;

  const taskRoute = SectionTitleToRoute[title]?.replace('{applicationId}', applicationId);

  const route = taskRoute
    ? generateFlowSpecificUrl({ url: taskRoute, params: { uni, applicantId: userId }, currentView: 'staff' })
    : undefined;

  const canEdit = hasPerm(role, P.EDIT_APPLY_LOCKED_APPLICATIONS);

  const isDisabled = !canEdit || !route;

  return (
    <Box display="flex" flexDir={'row'} alignItems="center" justifyContent="space-between" mb={8} mt={8}>
      <CustomHeading level="h1" flexGrow={1}>
        {title}
      </CustomHeading>
      <Button
        as={!isDisabled ? 'a' : undefined}
        href={!isDisabled ? route : undefined}
        isDisabled={isDisabled}
        size="sm"
        variant="outline"
      >
        Edit
      </Button>
    </Box>
  );
}
